module.exports = __webpack_public_path__ + "static/media/BM_Measurement.6ccb7d1e.svg";